import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import CommonDetailsContext from '../../context/Common/common';
import { useCommonDetailsContext } from '../../context/Common/common';
import { Alert } from '@mui/material';

interface State extends SnackbarOrigin {
  open: boolean;
}

export default function PositionedSnackbar() {
  const { snackBarData, setSnackBarData } = useCommonDetailsContext();
  const [state, setState] = React.useState<State>({
    open: false,
    vertical: 'top',
    horizontal: 'right',
  });
  const { vertical, horizontal, open } = state;

  

  const handleClose = () => {
    setState({ ...state, open: false });
    setSnackBarData({ snackBarMessage: "", snackBarIopen: false });
  };

  React.useEffect(() => {
    console.log("snackBarData useEffect", snackBarData);

    if (snackBarData.snackBarIopen) {
      setState({ ...state, open: true });
    } else{
      setState({ ...state, open: false });
    }
  }, [snackBarData])
  console.log("snackBarData outside", snackBarData, "state", state);

  return (
    <Box sx={{ width: 500 }}>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        message={snackBarData?.snackBarMessage}
        key={vertical + horizontal}
      />
    </Box>
  );
}
